import React from 'react';
import styled from 'styled-components';

const SpaceForDragWrapper = styled.div`
  // posizioniamo il div sopra il contenuto per nasconderlo
  z-index: 5;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  overflow: hidden;

  background-color: #fff;
  border-radius: 8px;

  margin: -2px;
  padding: 2px;
`;

const SpaceForDrag = styled.div`
  width: 100%;
  height: 100%;
  /* border: 4px dashed ${props => props.theme.colorPrimaryBg}; */
  background-color: ${props => props.theme.colorPrimaryBg};
  border-radius: 8px;
`;

export interface SpaceForDragIndicatorProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Visualizzazione per l'utente della posizione in cui sarà spostato il widget
 */
export function SpaceForDragIndicator(props: SpaceForDragIndicatorProps) {
  return (
    <SpaceForDragWrapper {...props}>
      <SpaceForDrag />
    </SpaceForDragWrapper>
  );
}
